const fontSizes = {
  "header-2xl": "2.25rem",
  "header-xl": "1.75rem",
  "header-lg": "1.375rem",
  header: "1.125rem",
  "header-sm": "1rem",
  "header-xs": "0.875rem",
  "header-2xs": "0.75rem",
  text: "1rem",
  "text-xl": "1.375rem",
  "text-lg": "1.125rem",
  "text-sm": "0.875rem",
  "text-xs": "0.75rem"
};
const fontWeights = {
  regular: "400",
  medium: "500",
  bold: "700"
};
const lineHeights = {
  // Iris line heights
  "header-2xl": "1.16",
  "header-xl": "1.18",
  "header-lg": "1.2",
  header: "1.22",
  "header-sm": "1.24",
  "header-xs": "1.26",
  "header-2xs": "1.28",
  text: "1.25",
  paragraph: "1.5",
  "text-xl": "1.52",
  "text-lg": "1.54",
  "text-sm": "1.58",
  "text-xs": "1.62"
};
const fonts = {
  heading: "Arial, system-ui, sans-serif",
  body: "Arial, system-ui, sans-serif"
};

export { fontSizes, fontWeights, fonts, lineHeights };
